import React, {PropsWithChildren} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {IReelSize} from "../../../types/IReelSize";

interface IProps extends PropsWithChildren {
    size: IReelSize;
    className?: string;
}

export const ReelAuthorName = (props: IProps) => {
    return (
        <Text size={props.size} className={props.className}>
            {props.children}
        </Text>
    );
};

const getFontStyleBySize = (size: IReelSize) => {
    switch (size) {
        case "S":
            return {
                fontSize: "0.843rem",
                lineHeight: "1.2rem"
            };
        case "M":
            return {
                fontSize: "0.983rem",
                lineHeight: "1.2rem"
            };
        case "L":
            return {
                fontSize: "1.4rem",
                lineHeight: "2rem"
            };
        case "XL":
            return {
                fontSize: "1.519rem",
                lineHeight: "2rem"
            };
    }
};

const Text = styled.div<{size: IReelSize}>`
    color: #fff;
    text-shadow: 0 1px 1px #000;
    font-family: ${({theme}) => theme.text.family.primary};
    font-style: normal;
    font-weight: 700;
    ${({size}) => {
        const {fontSize, lineHeight} = getFontStyleBySize(size);

        return css`
            font-size: ${fontSize};
            line-height: ${lineHeight};
        `;
    }};
`;
import React, {PropsWithChildren} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {IReelSize} from "../../../types/IReelSize";

interface IProps extends PropsWithChildren {
    size: IReelSize;
    className?: string;
}

export const ReelAuthorName = (props: IProps) => {
    return (
        <Text size={props.size} className={props.className}>
            {props.children}
        </Text>
    );
};

const getFontStyleBySize = (size: IReelSize) => {
    switch (size) {
        case "S":
            return {
                fontSize: "0.843rem",
                lineHeight: "1.2rem"
            };
        case "M":
            return {
                fontSize: "0.983rem",
                lineHeight: "1.2rem"
            };
        case "L":
            return {
                fontSize: "1.4rem",
                lineHeight: "2rem"
            };
        case "XL":
            return {
                fontSize: "1.519rem",
                lineHeight: "2rem"
            };
    }
};

const Text = styled.div<{size: IReelSize}>`
    color: #fff;
    text-shadow: 0 1px 1px #000;
    font-family: ${({theme}) => theme.text.family.primary};
    font-style: normal;
    font-weight: 700;
    ${({size}) => {
        const {fontSize, lineHeight} = getFontStyleBySize(size);

        return css`
            font-size: ${fontSize};
            line-height: ${lineHeight};
        `;
    }};
`;
